export default __webpack_public_path__ + "static/media/filtro.4f921ad6.svg";